import round from 'lodash-es/round'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'
import { buildSummaryReportPulseOxyLineChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/summary-line-chart/build-summary-report-pulse-oxy-line-chart-options'

export function buildHeartRateChartOption(options: {
  pulseRates: DataPoint[]
  timezone: string
  startTimestamp: number
  endTimestamp: number
  colors: VuetifyThemeItem | any // FIXME
}): any {
  const { pulseRates, timezone, startTimestamp, endTimestamp, colors } = options
  const dpMaxY = Math.max(...pulseRates.map(dp => dp.value))
  const dpMinY = Math.min(...pulseRates.map(dp => dp.value))
  const diffBetweenMinAndMaxDp = Math.max(10, dpMaxY - dpMinY)
  const maxY = Math.max(100, round(dpMaxY + diffBetweenMinAndMaxDp * 0.125))
  const minY = Math.min(40, round(dpMinY - diffBetweenMinAndMaxDp * 0.125))

  return buildSummaryReportPulseOxyLineChartOption({
    startTimestamp,
    endTimestamp,
    timezone,
    actualDataPoints: pulseRates,
    rollingAvgDataPoints: [],
    lineColor: colors.teal,
    unitLabel: 'bpm',
    markLineNumbers: [40, 60, 80, maxY],
    maxY,
    minY,
    gradientMinValue: 40,
    gradientMaxValue: 50,
    gradientMinColor: colors.teal,
    gradientMaxColor: colors.burgundy,
  })
}
